export default function (state, value) {
    state.options.legals = [];
    if (!value) return;
    value.forEach(i => {
        let value, label;
        if (i.value) value = i.value;
        if (i.Id) value = i.Id;
        if (i.label) label = i.label;
        if (i.Name) label = i.Name;
        state.options.legals.push({
            label,
            value,
        })
    });

}